import { QueryClient, queryOptions } from '@tanstack/react-query';

import type { AccountApi } from './client';

export const PROFILE_QUERY_KEY = ['me'] as const;

/** `GET /api/me` — shared by every page that shows the account. */
export function profileQuery(api: AccountApi) {
  return queryOptions({ queryKey: PROFILE_QUERY_KEY, queryFn: () => api.getProfile() });
}

/** Calm defaults: no automatic retries or refetch on focus — every error offers "Try again". */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: false, refetchOnWindowFocus: false, staleTime: 30_000 },
      mutations: { retry: false },
    },
  });
}
